module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"fiesta\"-in-garden-grove-california-974e0beeac66a0bd4528ee784191f0ec.png";